var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"grid-container"},[_c('bryntum-grid',_vm._b({ref:"PublishSessionsGrid",attrs:{"data":_vm.rawData,"height":_vm.height}},'bryntum-grid',_vm.PublishSessionsGridConfig,false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }